import { IMAGES, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "../lib/site";
import { FadeUp, MaskedLine } from "./Reveal";
import { Monogram } from "./Nav";

const Contact = () => (
    <section className="relative bg-noir text-white overflow-hidden" data-testid="contact-section">
        <div className="spotlight" />
        <div
            className="absolute right-0 top-0 bottom-0 w-[55%] pointer-events-none hidden md:block"
            aria-hidden="true"
            data-testid="contact-dissolve-image"
        >
            <img
                src={IMAGES.bath}
                alt=""
                loading="lazy"
                className="h-full w-full object-cover opacity-85"
                style={{
                    maskImage: "radial-gradient(ellipse 72% 68% at 58% 42%, black 28%, transparent 76%)",
                    WebkitMaskImage: "radial-gradient(ellipse 72% 68% at 58% 42%, black 28%, transparent 76%)",
                }}
            />
        </div>
        <div className="relative mx-auto max-w-[1440px] px-5 sm:px-10 pt-16 sm:pt-24 pb-10 sm:pb-14">
            <div className="max-w-3xl">
                <FadeUp>
                    <p className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-brass mb-6">
                        Begin
                    </p>
                </FadeUp>
                <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.6rem,6vw,5.5rem)]">
                    <MaskedLine>Ready for the best</MaskedLine>
                    <MaskedLine delay={0.1}>
                        bath of your <em className="italic text-brass">life?</em>
                    </MaskedLine>
                </h2>
                <FadeUp delay={0.2}>
                    <p className="mt-8 max-w-xl text-sm sm:text-base font-light leading-relaxed text-white/65">
                        Tell us about your bathroom on WhatsApp. Send a photo, get first thoughts and
                        a plan &mdash; now renovating bathrooms across Bangalore.
                    </p>
                </FadeUp>
                <FadeUp delay={0.3}>
                    <div className="mt-10 flex flex-wrap items-center gap-5">
                        <a
                            data-testid="contact-whatsapp-cta"
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex items-center gap-3 rounded-full bg-[#25D366] px-8 py-4 sm:px-10 sm:py-5 text-sm sm:text-base font-semibold text-noir transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_40px_rgba(37,211,102,0.35)]"
                        >
                            <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden="true">
                                <path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.96L2 22l5.18-1.5A9.9 9.9 0 1 0 12.04 2Zm5.78 14.06c-.24.68-1.4 1.3-1.94 1.35-.5.05-1.13.24-3.8-1.02-3.2-1.5-5.2-4.9-5.36-5.12-.15-.22-1.24-1.7-1.2-3.2.04-1.5.85-2.22 1.14-2.53.28-.3.62-.36.83-.35.24 0 .48 0 .69.02.22.01.52-.09.8.63.29.74.96 2.56 1.04 2.75.09.19.14.4.02.63-.12.24-.24.39-.42.6-.18.2-.38.36-.55.58-.17.2-.36.43-.16.8.2.37.9 1.53 1.94 2.47 1.33 1.22 2.45 1.58 2.8 1.75.34.18.55.15.75-.09.2-.24.87-1.01 1.1-1.36.23-.35.46-.28.77-.17.31.12 1.98.94 2.32 1.1.34.18.56.26.65.4.08.15.08.83-.16 1.51Z" />
                            </svg>
                            Chat with us on WhatsApp
                        </a>
                        <a
                            data-testid="contact-phone-link"
                            href={PHONE_TEL}
                            className="font-mono text-sm sm:text-base tracking-[0.1em] text-white/80 transition-colors duration-300 hover:text-brass"
                        >
                            {PHONE_DISPLAY}
                        </a>
                    </div>
                </FadeUp>
            </div>

            <div className="mt-24 sm:mt-36 border-t hairline-dark pt-8 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
                <Monogram />
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/40" data-testid="footer-domain">
                    bathandbeyond.co
                </p>
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/40">
                    &copy; 2026 Bath & Beyond &mdash; A Spaces by Samita Venture
                </p>
            </div>
        </div>
    </section>
);

export default Contact;
